import { Component, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-add-collaborator',
  templateUrl: './add-collaborator.component.html',
  styleUrls: ['./add-collaborator.component.scss'],
})
export class AddCollaboratorComponent extends BaseListCtl {
  @Input() curApp: any;
  roles: string[] = ['Reporter', 'Developer', 'Maintainer'];
  activeColumns: string[] = ['userId', 'role'];
  public datavalidate = true;
  public applicationRoles: any = [];
  public applications: any = [];
  public users: any = [];

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super(locator.config.get('endpoint.collaborator'), locator, route);
    let _self = this;
    _self.form['applicationId'] = 0;
  }

  /**
   * Populate data into form
   * @param form
   * @param data
   */
  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.userId = data.userId;
    form.userFirstname = data.userFirstname;
    form.role = data.role;
    form.applicationId = data.applicationId;
    form.applicationName = data.applicationName;
  }

  /**
   * On init
   */
  override ngOnInit() {
    //this.preload();
    this.search();
    this.getApplications();
    this.getUsers();
    this.getApplicationRoles();
  }

  /**
   * On changes
   * @param changes
   */
  public async ngOnChanges(changes: SimpleChanges) {
    let _self = this;
    if (changes['curApp']) {
      //this.preload();
      this.search();
      this.getApplications();
      this.getUsers();
      this.getApplicationRoles();
    }
  }

  /**
   * override Search to add applicationId in searchParams
   */
  override search(): void {
    let _self = this;
    (this.form.searchParams['applicationId'] = Number(this.curApp['id'])),
      super.search(function (error: any) {
        if (_self.form.searchMessage === 'Record not found') {
          _self.form.list = [];
        }
      });
  }

  /**
   * Save collaborator
   */
  override async save() {
    this.form.data['applicationId'] = this.curApp['id'];
    this.form.data['applicationName'] = this.curApp['name'];
    this.form.data['status'] = 'Pending';
    await this.checkDuplicate(
      this.form.data['loginId'],
      this.form.data['role']
    );
    if (this.datavalidate) {
      super.save();
    }
  }

  /**
   * Get applications Details
   */
  public async getApplications() {
    let _self = this;
    // get applications
    let url = this.locator.getEndpoint('endpoint.user') + '/applications';
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        console.log('Server Error:' + error);
        return;
      }
      _self.applications = res.result.data;
    });
  }

  /**
   * Get users
   */
  public async getUsers() {
    let _self = this;
    // get users
    let url = this.locator.getEndpoint('endpoint.user') + '/search/0';
    this.locator.http.post(url, {}, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.users = res.result.data;
    });
  }

  /**
   * Get Application Roles
   * @param id
   */
  public async getApplicationRoles() {
    let _self = this;
    let url = _self.endpoint + '/application-roles/' + _self.curApp['id'];
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.applicationRoles = res.result.data;
    });
  }

  /**
   * Check duplicate email and role
   * @param email
   * @param role
   * @returns
   */
  public async checkDuplicate(email: any, role: any) {
    let _self = this;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailPattern.test(email)) {
      console.error('Email is not valid');
      _self.form.error = true;
      _self.datavalidate = false;
      _self.form.inputerror['loginId'] = 'email not valid';
      return;
    }

    let dupEmail=_self.form.list.find(
      (dupEmail: {loginId:any}) =>
        dupEmail.loginId===email
    );

    if(dupEmail){
      _self.datavalidate = false;
      _self.form.error = true;
      _self.form.message ='This Email Id is already assigned to another role.';
      _self.form.list.loginId=null;
      console.error('User found:', dupEmail);
      return;
    }

    if (!role && role === 'undefined') {
      _self.datavalidate = false;
      console.error('datavalidate is false: roleId is missing or invalid');
      _self.form.inputerror['role'] = 'email not valid';
      return;
    }

    let user = _self.form.list.find(
      (user: { loginId: any; role: any }) =>
        user.loginId === email && user.role == role
    );
    if (user) {
      _self.datavalidate = false;
      _self.form.error = true;
      _self.form.message =
        'Duplicate application role for same user is not allowed';
      console.error('User found:', user);
      return;
    } else {
      _self.datavalidate = true;
      _self.form.error = false;
      _self.form.message = '';
      console.error('User not found');
    }

    // let url = _self.endpoint + '/checkDuplicate';
    // const searchparam: any = {};
    // searchparam['app_id'] = _self.curApp['id'];
    // searchparam['loginId'] = email;
    // searchparam['role'] = role;

    // this.locator.http.post(
    //   url,
    //   searchparam,
    //   async function (res: any, error: boolean) {
    //     if (error) {
    //       alert('Server Error:' + error);
    //       return;
    //     }
    //     if (res.success) {
    //       _self.datavalidate = false;
    //       _self.form.error = true;
    //       _self.form.message = 'Duplicate application role mapping';
    //       console.error('User found:', res.result.data[0]);
    //     } else {
    //       _self.datavalidate = true;
    //       _self.form.error = false;
    //       _self.form.message = '';
    //       console.error('User not found');
    //     }
    //   }
    // );
  }

  /**
   * Change collaborator status
   * @param id
   * @param status
   */
  public changeStatus(id: number, status: string) {
    let _self = this;

    _self.form.error = [];
    _self.form.message = '';

    let url =
      this.locator.getEndpoint('endpoint.collaborator') +
      '/changestatus/' +
      id +
      '/' +
      status;
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }

      _self.form.error = !res.success;
      _self.form.message = res.message;

      if (res.success) {
        _self.form.list.forEach((e: any) => {
          if (e.id === id) {
            e.status = res.result.data.status;
          }
        });
      } else {
        alert('Error: ' + res.message);
      }
    });
  }
}
